import { omit, } from 'lodash';

import firebase from './firebase';
import { batch, } from './shared/firebase';

const db = firebase.firestore();
const simulationsRef = db.collection('simulations');

const stripMeta = _ => omit(_, ['id', 'ref', 'isSimulationCreated']);

// changes をマスタへ書き込む。ここがマスタを変更する唯一の場所。
// 適用後は、他のシミュレーションも前提が崩れるため失効させる
export const applySimulationToMaster = async (simulation, tenantId, { operatedBy } = {}) => {
  const changes = simulation.changes ?? [];
  const simulationRef = simulationsRef.doc(simulation.id);

  // 適用前のマスタを退避する。戻せるようにするため
  const backupRef = simulationRef.collection('backups').doc();
  const targetIds = changes.filter(_ => _.type !== 'create');
  const befores = await Promise.all(
    targetIds.map(async (_) => {
      const doc = await db.collection(_.collectionName).doc(_.id).get();
      return doc.exists ? { collectionName: _.collectionName, id: _.id, values: doc.data() } : null;
    })
  );
  await backupRef.set({
    tenantId,
    createdAt: new Date(),
    items: befores.filter(Boolean),
  });

  if (changes.length > 0) {
    await batch(db, changes, (b, change) => {
      const ref = db.collection(change.collectionName).doc(change.id);
      if (change.type === 'delete') {
        b.delete(ref);
      } else if (change.type === 'create') {
        b.set(ref, { ...stripMeta(change.values), tenantId });
      } else {
        b.set(ref, stripMeta(change.values), { merge: true });
      }
      return ref;
    });
  }

  await simulationRef.update({
    appliedAt: new Date(),
    appliedBy: operatedBy ?? null,
    lastBackupId: backupRef.id,
  });

  // 他の有効なシミュレーションは、マスタが動いたことで前提が崩れるため失効させる
  const { docs } = await simulationsRef
    .where('tenantId', '==', tenantId)
    .where('appliedAt', '==', null)
    .where('staleAt', '==', null)
    .get();
  const others = docs.filter(_ => _.id !== simulation.id);
  if (others.length > 0) {
    await batch(db, others, (b, doc) => {
      b.update(doc.ref, {
        staleAt: new Date(),
        staleReason: `「${simulation.name}」がマスタに適用されたため`,
      });
      return doc.ref;
    });
  }

  return backupRef;
};

// シミュレーションを破棄する。マスタは元々触っていないので、ドキュメントを消すだけ
export const discardSimulation = async (simulationId) => {
  const simulationRef = simulationsRef.doc(simulationId);
  const { docs } = await simulationRef.collection('backups').get();
  if (docs.length > 0) {
    await batch(db, docs, (b, doc) => {
      b.delete(doc.ref);
      return doc.ref;
    });
  }
  await simulationRef.delete();
};
